import { Component, ElementRef, Input, OnChanges, Renderer2 } from "@angular/core";
import { IPlot } from "@interfaces/IPlot";
import { CanvasService } from "@services/canvas.service";
import { VeriMarkerService } from "@services/veriMarker.service";
import "./veriMarker.scss";

@Component({
    selector: 'veri-marker',
    template: ''
})
export class VeriMarkerComponent implements OnChanges {
    @Input() plot: IPlot;

    markerImage: string;
    canvas: HTMLCanvasElement;

    constructor(
        private element: ElementRef,
        private renderer: Renderer2,
        private readonly canvasService: CanvasService,
        private readonly veriMarkerService: VeriMarkerService) { }

    ngOnChanges() {
        this.updateImage();
    }

    private createCanvas() {
        if (this.canvas) {
            return;
        }

        var markerOptions = this.veriMarkerService.createVeriMarkerOptions(this.plot);
        var size = this.veriMarkerService.getMarkerSize(markerOptions);

        this.canvas = this.canvasService.createHiDPICanvas(size, size);
        this.renderer.appendChild(this.element.nativeElement, this.canvas);
    }

    private updateImage() {
        this.createCanvas();

        var markerOptions = this.veriMarkerService.createVeriMarkerOptions(this.plot);
        this.veriMarkerService.generateMarkerImageCanvas(markerOptions, this.canvas);
    }
}
